import { useEffect, useState } from 'react';
import { fetchPartesCliente } from '../services/partes';
import type { ParteReplicaRow } from '../types/clientes';

// Historial bajo demanda. Igual que `useFichaCliente`: sin cliente no se
// consulta, y se descartan respuestas obsoletas al cambiar de llamada.
//
// `cargando` y `fallo` importan de verdad aquí: el panel tiene que distinguir
// tres cosas que se parecen —"todavía no lo sé", "no lo he podido consultar" y
// "este cliente no tiene partes"— y el criterio de aceptación lo exige.
export function usePartesCliente(idCliente: string | null): {
  partes: ParteReplicaRow[];
  cargando: boolean;
  fallo: boolean;
} {
  const [partes, setPartes] = useState<ParteReplicaRow[]>([]);
  const [cargando, setCargando] = useState(false);
  const [fallo, setFallo] = useState(false);

  useEffect(() => {
    if (!idCliente) {
      setPartes([]);
      setCargando(false);
      setFallo(false);
      return;
    }
    let vigente = true;
    setCargando(true);
    setFallo(false);
    fetchPartesCliente(idCliente)
      .then((p) => {
        if (!vigente) return;
        setPartes(p);
        setCargando(false);
      })
      .catch(() => {
        if (!vigente) return;
        // El fallo NO se traga en una lista vacía: "no tiene partes" y "no he
        // podido consultarlo" son cosas distintas, y confundirlas hace que
        // quien atiende le diga al cliente que no consta ninguna intervención
        // cuando lo que ha pasado es que la consulta ha fallado.
        setPartes([]);
        setCargando(false);
        setFallo(true);
      });
    return () => {
      vigente = false;
    };
  }, [idCliente]);

  return { partes, cargando, fallo };
}
